import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter, Redirect } from 'react-router'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import ProgressBar, {
  ProgressBarContainerWizard
} from 'src/components/atoms/ProgressBar'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import FormContainer from 'src/components/containers/FormContainer'
import Answer from 'src/components/atoms/wizard/Answer'
import { StoreProps } from 'src/stores'

interface State {
  valid: boolean
  noRedirect: boolean
}

const nudges = new Map([
  [
    'BURIAL',
    'Die Erdbestattung ist die traditionellste Form der Bestattung. Eine sehr gute Wahl.'
  ],
  [
    'CREMATION',
    'Die Feuerbestattung ist mittlerweile die beliebteste Bestattungsform. Eine sehr gute Wahl.'
  ],
  [
    'TREE_FUNERAL',
    'Immer mehr Menschen entscheiden sich für die Baumbestattung als natürliche Bestattungsform.'
  ],
  [
    'SEA_FUNERAL',
    'Eine Donaubestattung bietet einen ganz besonderen Rahmen für den Abschied.'
  ]
])

@inject('wizardStore')
@observer
export class PickupLocationInput extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    const query = new URLSearchParams(location.search)
    this.state = {
      valid: !!wizardStore.deceasedLocation.locationType,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_acutePickup' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_acutePickup' })
  }

  decideNudge = () => {
    const { wizardStore } = this.props
    return nudges.get(wizardStore.basics.funeralType)
  }

  handleAnswerClick = (key) => {
    const { wizardStore } = this.props
    if (this.isChecked(key)) {
      wizardStore.deceasedLocation.locationType = null
      this.setState({ valid: false })
    } else {
      wizardStore.deceasedLocation.locationType = key
      this.setState({ valid: true })
    }
  }

  isChecked = (id) => {
    const { wizardStore } = this.props
    return id === wizardStore.deceasedLocation.locationType
  }

  renderAnswer = (key, text) => {
    return (
      <Answer
        answerKey={key}
        checked={this.isChecked(key)}
        onClick={() => this.handleAnswerClick(key)}>
        {text}
      </Answer>
    )
  }

  render() {
    const { wizardStore } = this.props
    const { valid, noRedirect } = this.state

    if (!wizardStore.basics.planningReason && !noRedirect)
      return <Redirect to='/planung/start/' />

    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={30} end={60}>
              <p>
                <i className='fas fa-check'></i>
                {this.decideNudge()}
              </p>
            </ProgressBar>
          </ProgressBarContainerWizard>
          <Question>Wo befindet sich die verstorbene Person zurzeit?</Question>
          <FormContainer>
            {this.renderAnswer('HOME', 'Zu Hause')}
            {this.renderAnswer('HOSPITAL', 'Im Krankenhaus')}
            {this.renderAnswer('ELDERLY_CARE', 'Im Pflegeheim / Hospiz')}
            {this.renderAnswer('ANOTHER_UNDERTAKER', 'Anderer Bestatter')}
            {this.renderAnswer('OTHER', 'Anderswo')}
          </FormContainer>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={!valid}
        />
      </WizardContainer>
    )
  }
}

export default withRouter(PickupLocationInput)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/acute/PickupLocationInput.tsx